import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Result from "./Result";

class ResultsList extends PureComponent {
  state = {
    results: []
  };

  static getDerivedStateFromProps(props, state) {
    if (props.results != null && state.results !== props.results) {
      return {
        ...state,
        results: props.results
      };
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.state.results.map((result, index) => {
          return <Result result={result} index={index} key={index} />;
        })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { results: state.searchData.results };
};

export default connect(
  mapStateToProps,
  null
)(ResultsList);
